import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Info } from "lucide-react";
import { AtlasMark } from "./AtlasLogo";
import { ZERO_COMMISSION, NOT_ADVICE } from "./Disclaimers";

export const Footer = () => (
  <footer className="border-t bg-[hsl(var(--background))] mt-16" data-testid="global-footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
      <div className="grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <AtlasMark size={32} />
            <span className="font-display font-bold tracking-tight text-[hsl(var(--atlas-navy))]">ATLAS ADVISORY</span>
          </div>
          <p className="mt-3 text-sm text-muted-foreground max-w-xs">
            Commission-free citizenship &amp; residency intelligence. Find what you already qualify for, with the sources to prove it.
          </p>
        </div>
        <div>
          <div className="text-sm font-semibold text-[hsl(var(--atlas-navy))] mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/check" className="hover:text-[hsl(var(--atlas-navy-2))]">Check eligibility</Link></li>
            <li><Link to="/tax" className="hover:text-[hsl(var(--atlas-navy-2))]">Tax Explorer</Link></li>
            <li><Link to="/about" className="hover:text-[hsl(var(--atlas-navy-2))]">Methodology</Link></li>
            <li><Link to="/privacy" className="hover:text-[hsl(var(--atlas-navy-2))]">Privacy</Link></li>
          </ul>
        </div>
        <div className="space-y-3">
          <div className="flex items-start gap-2 rounded-lg border bg-white/60 p-3" data-testid="footer-zero-commission-statement">
            <ShieldCheck className="h-4 w-4 mt-0.5 shrink-0 text-[hsl(var(--success))]" />
            <p className="text-xs text-[hsl(var(--atlas-slate))]">{ZERO_COMMISSION}</p>
          </div>
          <div className="flex items-start gap-2 rounded-lg border bg-white/60 p-3" data-testid="footer-not-advice-disclaimer">
            <Info className="h-4 w-4 mt-0.5 shrink-0 text-[hsl(var(--atlas-steel))]" />
            <p className="text-xs text-[hsl(var(--atlas-slate))]">{NOT_ADVICE}</p>
          </div>
        </div>
      </div>
      <div className="atlas-divider mt-8 rounded-full" />
      <div className="mt-4 text-xs text-muted-foreground">© {new Date().getFullYear()} Atlas Advisory. All rights reserved.</div>
    </div>
  </footer>
);
